"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.submitActionValuesSchema = exports.ssrValuesSchema = exports.distributionMethodValuesSchema = exports.demoPageParamsSchema = void 0;
var _zod = require("zod");
var _formMetadataParams = require("../formMetadataParams");
const ssrValuesSchema = exports.ssrValuesSchema = _zod.z.enum(["on", "off"]);
const submitActionValuesSchema = exports.submitActionValuesSchema = _zod.z.enum(["slider", "results"]);
const distributionMethodValuesSchema = exports.distributionMethodValuesSchema = _zod.z.enum(["module-federation", "webpart"]);
const demoPageParamsSchema = exports.demoPageParamsSchema = _zod.z.intersection(_formMetadataParams.formMetadataParamsSchema, _zod.z.object({
  ssr: ssrValuesSchema.default("on"),
  submitAction: submitActionValuesSchema.default("slider"),
  distributionMethod: distributionMethodValuesSchema.default("module-federation"),
  debug: _zod.z.boolean().default(false),
  instanceId: _zod.z.string().optional()
}));